export default __webpack_public_path__ + "static/The_extreme_life_of_Europes_sherpas-28c93ac46118487654c765e41e630fbb.jpg";